// import React, { useState } from "react";
// import axios from "axios";
// import { Loader2, X, AlertCircle } from "lucide-react";
// import { uploadToCloudinary } from "../../../utils/cloudinary";
// import Swal from "sweetalert2";

// const CareerCreateModal = ({ onClose, onSuccess }) => {
//   const [formData, setFormData] = useState({
//     position: "",
//     jobType: "Full Time",
//     company: {
//       companyLogo: null,
//       companyName: "",
//       jobLocation: "",
//     },
//     jobDetail: {
//       salary: "",
//       salaryCurrency: "INR",
//       jobOpenings: "",
//     },
//   });

//   const [companyLogoPreview, setCompanyLogoPreview] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleCompanyChange = (field, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       company: { ...prev.company, [field]: value },
//     }));
//   };

//   const handleJobDetailChange = (field, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       jobDetail: { ...prev.jobDetail, [field]: value },
//     }));
//   };

//   const handleCompanyLogo = (e) => {
//     const file = e.target.files[0];
//     setFormData((prev) => ({
//       ...prev,
//       company: { ...prev.company, companyLogo: file },
//     }));
//     const reader = new FileReader();
//     reader.onloadend = () => setCompanyLogoPreview(reader.result);
//     reader.readAsDataURL(file);
//   };

//   const validate = () => {
//     if (!formData.position.trim()) return "Position is required";
//     if (!formData.jobType.trim()) return "Job type is required";
//     if (!formData.company.companyName.trim()) return "Company name is required";
//     if (!formData.company.jobLocation.trim()) return "Job location is required";
//     if (!formData.jobDetail.salary.trim()) return "Salary is required";
//     if (!formData.jobDetail.salaryCurrency.trim()) return "Salary currency is required";
//     if (!formData.jobDetail.jobOpenings.trim()) return "Job openings is required";

//     // Validate jobOpenings is a positive number
//     const jobOpenings = parseInt(formData.jobDetail.jobOpenings);
//     if (isNaN(jobOpenings) || jobOpenings < 1) {
//       return "Job openings must be a positive number";
//     }

//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validation = validate();
//     if (validation) return setError(validation);

//     setLoading(true);
//     setError(null);

//     try {
//       let companyLogoUrl = "";
//       if (formData.company.companyLogo) {
//         companyLogoUrl = await uploadToCloudinary(formData.company.companyLogo);
//       }

//       const companyData = {
//         companyLogo: companyLogoUrl,
//         companyName: formData.company.companyName,
//         jobLocation: formData.company.jobLocation,
//         socialLinks: [], // Empty array as it's not needed
//       };

//       const jobDetailData = {
//         jobDescription: [""], // Default empty array
//         requirements: [""], // Default empty array
//         desirable: [], // Default empty array
//         benefits: [], // Default empty array
//         salary: formData.jobDetail.salary,
//         salaryCurrency: formData.jobDetail.salaryCurrency,
//         jobOpenings: parseInt(formData.jobDetail.jobOpenings),
//         salaryType: "per month", // Default value
//         overview: [], // Default empty array
//       };

//       const submitData = {
//         position: formData.position,
//         jobType: formData.jobType,
//         company: companyData,
//         jobDetail: jobDetailData,
//       };

//       const res = await axios.post(
//         `${process.env.REACT_APP_API_URL}/career/create-career`,
//         submitData,
//         // { withCredentials: true }
//       );

//       if (res.data.success) {
//         onSuccess();
//         onClose();
//         Swal.fire("Created", "Career created successfully.", "success");
//       }
//     } catch (err) {
//       console.error(err);
//       setError(err.response?.data?.message || "Failed to create career");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
//       <div className="bg-white rounded-2xl shadow-lg w-full max-w-2xl max-h-[95vh] overflow-y-auto">
//         <div className="sticky top-0 bg-gradient-to-r from-[#0bb6d9] to-[#3cd7f6] text-white p-6 flex justify-between items-center rounded-t-2xl">
//           <h2 className="text-lg font-semibold text-white">Create New Career</h2>
//           <button
//             onClick={onClose}
//             className="hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition"
//           >
//             <X className="w-6 h-6" />
//           </button>
//         </div>

//         <form onSubmit={handleSubmit} className="p-6 space-y-6">
//           {error && (
//             <div className="flex items-center gap-2 bg-red-50 text-red-600 px-4 py-3 rounded-lg">
//               <AlertCircle className="w-5" /> {error}
//             </div>
//           )}

//           {/* Basic Information */}
//           <div className="grid md:grid-cols-2 gap-6">
//             <div>
//               <label className="block font-semibold text-gray-700 mb-1">
//                 Position *
//               </label>
//               <input
//                 type="text"
//                 name="position"
//                 value={formData.position}
//                 onChange={handleInputChange}
//                 placeholder="Enter position"
//                 className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//               />
//             </div>

//             <div>
//               <label className="block font-semibold text-gray-700 mb-1">
//                 Job Type *
//               </label>
//               <select
//                 name="jobType"
//                 value={formData.jobType}
//                 onChange={handleInputChange}
//                 className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//               >
//                 <option value="Full Time">Full Time</option>
//                 <option value="Part Time">Part Time</option>
//                 <option value="Internship">Internship</option>
//                 <option value="Freelance">Freelance</option>
//               </select>
//             </div>
//           </div>

//           {/* Company Information */}
//           <div className="border rounded-xl p-4 space-y-4">
//             <h4 className="font-semibold text-gray-800">Company Information *</h4>

//             <div className="grid md:grid-cols-2 gap-4">
//               <div>
//                 <label className="block font-semibold text-gray-700 mb-1">
//                   Company Name *
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.company.companyName}
//                   onChange={(e) => handleCompanyChange("companyName", e.target.value)}
//                   placeholder="Enter company name"
//                   className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                 />
//               </div>

//               <div>
//                 <label className="block font-semibold text-gray-700 mb-1">
//                   Job Location *
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.company.jobLocation}
//                   onChange={(e) => handleCompanyChange("jobLocation", e.target.value)}
//                   placeholder="Enter job location"
//                   className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                 />
//               </div>
//             </div>

//             <div>
//               <label className="block font-semibold text-gray-700 mb-1">
//                 Company Logo
//               </label>
//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={handleCompanyLogo}
//                 className="w-full text-sm text-gray-500 file:mr-4 file:py-1 file:px-3 file:rounded file:border-0 file:bg-[#0bb6d9] file:text-white hover:file:bg-[#069ab7]"
//               />
//               {companyLogoPreview && (
//                 <img
//                   src={companyLogoPreview}
//                   alt="Company logo preview"
//                   className="w-28 h-28 mt-2 rounded object-cover"
//                 />
//               )}
//             </div>
//           </div>

//           {/* Job Details */}
//           <div className="border rounded-xl p-4 space-y-4">
//             <h4 className="font-semibold text-gray-800">Job Details *</h4>
//             <div className="grid md:grid-cols-3 gap-4">
//               <div>
//                 <label className="block font-semibold text-gray-700 mb-1">
//                   Salary *
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.jobDetail.salary}
//                   onChange={(e) => handleJobDetailChange("salary", e.target.value)}
//                   placeholder="e.g., 70000"
//                   className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                 />
//               </div>

//               <div>
//                 <label className="block font-semibold text-gray-700 mb-1">
//                   Currency *
//                 </label>
//                 <select
//                   value={formData.jobDetail.salaryCurrency}
//                   onChange={(e) => handleJobDetailChange("salaryCurrency", e.target.value)}
//                   className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                 >
//                   <option value="INR">INR</option>
//                   <option value="USD">USD</option>
//                   <option value="EUR">EUR</option>
//                   <option value="GBP">GBP</option>
//                 </select>
//               </div>

//               <div>
//                 <label className="block font-semibold text-gray-700 mb-1">
//                   Job Openings *
//                 </label>
//                 <input
//                   type="number"
//                   min="1"
//                   value={formData.jobDetail.jobOpenings}
//                   onChange={(e) => handleJobDetailChange("jobOpenings", e.target.value)}
//                   placeholder="e.g., 5"
//                   className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Action Buttons */}
//           <div className="flex items-center gap-5 pt-4 border-t">
//             <button
//               type="button"
//               onClick={onClose}
//               className="px-4 w-full py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={loading}
//               className="px-5 py-2 w-full rounded-lg bg-[#0BB6D9] text-white hover:bg-cyan-700 flex items-center justify-center gap-2"
//             >
//               {loading && <Loader2 className="animate-spin w-4 h-4" />}
//               <span>Create Career</span>
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default CareerCreateModal;
import React, { useState } from "react";
import axios from "axios";
import { Loader2, X, AlertCircle } from "lucide-react";
import { uploadToCloudinary } from "../../../utils/cloudinary";
import Swal from "sweetalert2";

const CareerCreateModal = ({ onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    position: "",
    companyLogo: null,
    jobOpenings: "",
  });

  const [companyLogoPreview, setCompanyLogoPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCompanyLogo = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, companyLogo: file }));
      const reader = new FileReader();
      reader.onloadend = () => setCompanyLogoPreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const validate = () => {
    if (!formData.position.trim()) return "Position is required";
    if (!formData.jobOpenings.trim()) return "Job openings is required";

    const jobOpenings = parseInt(formData.jobOpenings);
    if (isNaN(jobOpenings) || jobOpenings < 1) {
      return "Job openings must be a positive number";
    }

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validation = validate();
    if (validation) return setError(validation);

    setLoading(true);
    setError(null);

    try {
      let companyLogoUrl = "";
      if (formData.companyLogo) {
        companyLogoUrl = await uploadToCloudinary(formData.companyLogo);
      }

      const submitData = {
        position: formData.position,
        companyLogo: companyLogoUrl,
        jobOpenings: parseInt(formData.jobOpenings),
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/career/create-career`,
        submitData
      );

      if (res.data.success) {
        onSuccess();
        onClose();
        Swal.fire("Created", "Career created successfully.", "success");
      }
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Failed to create career");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-2xl max-h-[95vh] overflow-y-auto">
        <div className="sticky top-0 bg-gradient-to-r from-[#0bb6d9] to-[#3cd7f6] text-white p-6 flex justify-between items-center rounded-t-2xl">
          <h2 className="text-lg font-semibold text-white">Create New Career</h2>
          <button
            onClick={onClose}
            className="hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {error && (
            <div className="flex items-center gap-2 bg-red-50 text-red-600 px-4 py-3 rounded-lg">
              <AlertCircle className="w-5" /> {error}
            </div>
          )}

          {/* Position */}
          <div>
            <label className="block font-semibold text-gray-700 mb-1">
              Position *
            </label>
            <input
              type="text"
              name="position"
              value={formData.position}
              onChange={handleInputChange}
              placeholder="Enter position"
              className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
              required
            />
          </div>

          {/* Company Logo */}
          <div>
            <label className="block font-semibold text-gray-700 mb-1">
              Company Logo
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={handleCompanyLogo}
              className="w-full text-sm text-gray-500 file:mr-4 file:py-1 file:px-3 file:rounded file:border-0 file:bg-[#0bb6d9] file:text-white hover:file:bg-[#069ab7]"
            />
            {companyLogoPreview && (
              <img
                src={companyLogoPreview}
                alt="Company logo preview"
                className="w-28 h-28 mt-2 rounded object-cover"
              />
            )}
          </div>

          {/* Job Openings */}
          <div>
            <label className="block font-semibold text-gray-700 mb-1">
              Job Openings *
            </label>
            <input
              type="number"
              name="jobOpenings"
              min="1"
              value={formData.jobOpenings}
              onChange={handleInputChange}
              placeholder="e.g., 5"
              className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
              required
            />
          </div>

          {/* Action Buttons */}
          <div className="flex items-center gap-5 pt-4 border-t">
            <button
              type="button"
              onClick={onClose}
              className="px-4 w-full py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-5 py-2 w-full rounded-lg bg-[#0BB6D9] text-white hover:bg-cyan-700 flex items-center justify-center gap-2"
            >
              {loading && <Loader2 className="animate-spin w-4 h-4" />}
              <span>Create Career</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CareerCreateModal;

// import React, { useState } from "react";
// import axios from "axios";
// import { Loader2, X, Plus, Trash2, AlertCircle } from "lucide-react";
// import { uploadToCloudinary } from "../../../utils/cloudinary";
// import Swal from "sweetalert2";

// const CareerCreateModal = ({ onClose, onSuccess }) => {
//   const [formData, setFormData] = useState({
//     position: "",
//     jobType: "Full Time",
//     company: {
//       companyLogo: null,
//       companyName: "",
//       jobLocation: "",
//       socialLinks: [{ icon: null, iconPreview: "", link: "" }],
//     },
//     jobDetail: {
//       jobDescription: [""],
//       requirements: [""],
//       desirable: [""],
//       benefits: [""],
//       salary: "",
//       salaryCurrency: "USD",
//       salaryType: "per year",
//       overview: [{ icon: null, iconPreview: "", title: "", jobPostedDate: "" }],
//     },
//   });

//   const [companyLogoPreview, setCompanyLogoPreview] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleCompanyChange = (field, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       company: { ...prev.company, [field]: value },
//     }));
//   };

//   const handleSocialLinkChange = (index, field, value) => {
//     const updated = [...formData.company.socialLinks];
//     updated[index][field] = value;
//     setFormData({
//       ...formData,
//       company: { ...formData.company, socialLinks: updated },
//     });
//   };

//   const handleSocialLinkIcon = (index, file) => {
//     const reader = new FileReader();
//     reader.onloadend = () => {
//       const updated = [...formData.company.socialLinks];
//       updated[index].icon = file;
//       updated[index].iconPreview = reader.result;
//       setFormData({
//         ...formData,
//         company: { ...formData.company, socialLinks: updated },
//       });
//     };
//     reader.readAsDataURL(file);
//   };

//   const addSocialLink = () =>
//     setFormData({
//       ...formData,
//       company: {
//         ...formData.company,
//         socialLinks: [...formData.company.socialLinks, { icon: null, iconPreview: "", link: "" }],
//       },
//     });

//   const removeSocialLink = (index) => {
//     const updated = formData.company.socialLinks.filter((_, i) => i !== index);
//     setFormData({
//       ...formData,
//       company: {
//         ...formData.company,
//         socialLinks: updated.length ? updated : [{ icon: null, iconPreview: "", link: "" }],
//       },
//     });
//   };

//   const handleCompanyLogo = (e) => {
//     const file = e.target.files[0];
//     setFormData((prev) => ({
//       ...prev,
//       company: { ...prev.company, companyLogo: file },
//     }));
//     const reader = new FileReader();
//     reader.onloadend = () => setCompanyLogoPreview(reader.result);
//     reader.readAsDataURL(file);
//   };

//   const handleJobDetailChange = (field, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       jobDetail: { ...prev.jobDetail, [field]: value },
//     }));
//   };

//   const handleArrayFieldChange = (field, index, value) => {
//     const updated = [...formData.jobDetail[field]];
//     updated[index] = value;
//     setFormData({
//       ...formData,
//       jobDetail: { ...formData.jobDetail, [field]: updated },
//     });
//   };

//   const addArrayFieldItem = (field) =>
//     setFormData({
//       ...formData,
//       jobDetail: {
//         ...formData.jobDetail,
//         [field]: [...formData.jobDetail[field], ""],
//       },
//     });

//   const removeArrayFieldItem = (field, index) => {
//     const updated = formData.jobDetail[field].filter((_, i) => i !== index);
//     setFormData({
//       ...formData,
//       jobDetail: {
//         ...formData.jobDetail,
//         [field]: updated.length ? updated : [""],
//       },
//     });
//   };

//   const handleOverviewChange = (index, field, value) => {
//     const updated = [...formData.jobDetail.overview];
//     updated[index][field] = value;
//     setFormData({
//       ...formData,
//       jobDetail: { ...formData.jobDetail, overview: updated },
//     });
//   };

//   const handleOverviewIcon = (index, file) => {
//     const reader = new FileReader();
//     reader.onloadend = () => {
//       const updated = [...formData.jobDetail.overview];
//       updated[index].icon = file;
//       updated[index].iconPreview = reader.result;
//       setFormData({
//         ...formData,
//         jobDetail: { ...formData.jobDetail, overview: updated },
//       });
//     };
//     reader.readAsDataURL(file);
//   };

//   const addOverview = () =>
//     setFormData({
//       ...formData,
//       jobDetail: {
//         ...formData.jobDetail,
//         overview: [
//           ...formData.jobDetail.overview,
//           { icon: null, iconPreview: "", title: "", jobPostedDate: "" },
//         ],
//       },
//     });

//   const removeOverview = (index) => {
//     const updated = formData.jobDetail.overview.filter((_, i) => i !== index);
//     setFormData({
//       ...formData,
//       jobDetail: {
//         ...formData.jobDetail,
//         overview: updated.length
//           ? updated
//           : [{ icon: null, iconPreview: "", title: "", jobPostedDate: "" }],
//       },
//     });
//   };

//   const validate = () => {
//     if (!formData.position.trim()) return "Position is required";
//     if (!formData.jobType.trim()) return "Job type is required";

//     if (!formData.company.companyLogo) return "Company logo is required";
//     if (!formData.company.companyName.trim()) return "Company name is required";
//     if (!formData.company.jobLocation.trim()) return "Job location is required";
//     if (formData.company.socialLinks.some(link => !link.icon || !link.link.trim()))
//       return "All social links must have both icon and link";

//     if (!formData.jobDetail.salary.trim()) return "Salary is required";
//     if (!formData.jobDetail.salaryCurrency.trim()) return "Salary currency is required";
//     if (!formData.jobDetail.salaryType.trim()) return "Salary type is required";
//     if (formData.jobDetail.jobDescription.some(desc => !desc.trim()))
//       return "All job descriptions are required";
//     if (formData.jobDetail.requirements.some(req => !req.trim()))
//       return "All requirements are required";
//     if (formData.jobDetail.overview.some(ov => !ov.icon || !ov.title.trim() || !ov.jobPostedDate.trim()))
//       return "All overview items must have icon, title, and job posted date";

//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validation = validate();
//     if (validation) return setError(validation);

//     setLoading(true);
//     setError(null);

//     try {
//       const companyLogoUrl = await uploadToCloudinary(formData.company.companyLogo);

//       const socialLinksWithUploads = await Promise.all(
//         formData.company.socialLinks.map(async (link) => {
//           const iconUrl = await uploadToCloudinary(link.icon);
//           return {
//             icon: iconUrl,
//             link: link.link.trim(),
//           };
//         })
//       );

//       const overviewWithUploads = await Promise.all(
//         formData.jobDetail.overview.map(async (item) => {
//           const iconUrl = await uploadToCloudinary(item.icon);
//           return {
//             icon: iconUrl,
//             title: item.title.trim(),
//             jobPostedDate: item.jobPostedDate.trim(),
//           };
//         })
//       );

//       const companyData = {
//         companyLogo: companyLogoUrl,
//         companyName: formData.company.companyName,
//         jobLocation: formData.company.jobLocation,
//         socialLinks: socialLinksWithUploads,
//       };

//       const jobDetailData = {
//         jobDescription: formData.jobDetail.jobDescription.filter(desc => desc.trim()),
//         requirements: formData.jobDetail.requirements.filter(req => req.trim()),
//         desirable: formData.jobDetail.desirable.filter(desc => desc.trim()),
//         benefits: formData.jobDetail.benefits.filter(benefit => benefit.trim()),
//         salary: formData.jobDetail.salary,
//         salaryCurrency: formData.jobDetail.salaryCurrency,
//         salaryType: formData.jobDetail.salaryType,
//         overview: overviewWithUploads,
//       };

//       const submitData = {
//         position: formData.position,
//         jobType: formData.jobType,
//         company: companyData,
//         jobDetail: jobDetailData,
//       };

//       const res = await axios.post(
//         `${process.env.REACT_APP_API_URL}/career/create-career`,
//         submitData,
//         // { withCredentials: true }
//       );

//       if (res.data.success) {
//         onSuccess();
//         onClose();
//         Swal.fire("Created", "Career created successfully.", "success");
//       }
//     } catch (err) {
//       console.error(err);
//       setError(err.response?.data?.message || "Failed to create career");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
//       <div className="bg-white rounded-2xl shadow-lg w-full max-w-4xl max-h-[95vh] overflow-y-auto">
//         <div className="sticky top-0 bg-gradient-to-r from-[#0bb6d9] to-[#3cd7f6] text-white p-6 flex justify-between items-center rounded-t-2xl">
//           <h2 className="text-lg font-semibold text-white">Create New Career</h2>
//           <button
//             onClick={onClose}
//             className="hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition"
//           >
//             <X className="w-6 h-6" />
//           </button>
//         </div>

//         <form onSubmit={handleSubmit} className="p-6 space-y-6">
//           {error && (
//             <div className="flex items-center gap-2 bg-red-50 text-red-600 px-4 py-3 rounded-lg">
//               <AlertCircle className="w-5" /> {error}
//             </div>
//           )}

//           <div className="grid md:grid-cols-2 gap-6">
//             <div>
//               <label className="block font-semibold text-gray-700 mb-1">
//                 Position *
//               </label>
//               <input
//                 type="text"
//                 name="position"
//                 value={formData.position}
//                 onChange={handleInputChange}
//                 placeholder="Enter position"
//                 className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//               />
//             </div>

//             <div>
//               <label className="block font-semibold text-gray-700 mb-1">
//                 Job Type *
//               </label>
//               <select
//                 name="jobType"
//                 value={formData.jobType}
//                 onChange={handleInputChange}
//                 className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//               >
//                 <option value="Full Time">Full Time</option>
//                 <option value="Part Time">Part Time</option>
//                 <option value="Internship">Internship</option>
//                 <option value="Freelance">Freelance</option>
//               </select>
//             </div>
//           </div>

//           <div className="border rounded-xl p-4 space-y-4">
//             <h4 className="font-semibold text-gray-800">Company Information *</h4>

//             <div className="grid md:grid-cols-2 gap-4">
//               <div>
//                 <label className="block font-semibold text-gray-700 mb-1">
//                   Company Name *
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.company.companyName}
//                   onChange={(e) => handleCompanyChange("companyName", e.target.value)}
//                   placeholder="Enter company name"
//                   className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                 />
//               </div>

//               <div>
//                 <label className="block font-semibold text-gray-700 mb-1">
//                   Job Location *
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.company.jobLocation}
//                   onChange={(e) => handleCompanyChange("jobLocation", e.target.value)}
//                   placeholder="Enter job location"
//                   className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                 />
//               </div>
//             </div>

//             <div>
//               <label className="block font-semibold text-gray-700 mb-1">
//                 Company Logo *
//               </label>
//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={handleCompanyLogo}
//                 className="w-full text-sm text-gray-500 file:mr-4 file:py-1 file:px-3 file:rounded file:border-0 file:bg-[#0bb6d9] file:text-white hover:file:bg-[#069ab7]"
//               />
//               {companyLogoPreview && (
//                 <img
//                   src={companyLogoPreview}
//                   alt="Company logo preview"
//                   className="w-28 h-28 mt-2 rounded object-cover"
//                 />
//               )}
//             </div>

//             <div>
//               <label className="block font-semibold text-gray-700 mb-1">
//                 Social Links *
//               </label>
//               {formData.company.socialLinks.map((link, index) => (
//                 <div key={index} className="space-y-3 p-4 border rounded-lg bg-gray-50">
//                   <div className="flex gap-2">
//                     <div className="flex-1">
//                       <label className="block text-sm text-gray-600 mb-1">Social Link URL *</label>
//                       <input
//                         type="url"
//                         placeholder="https://linkedin.com/company/example"
//                         value={link.link}
//                         onChange={(e) => handleSocialLinkChange(index, "link", e.target.value)}
//                         className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                       />
//                     </div>
//                   </div>

//                   <div className="grid md:grid-cols-2 gap-4">
//                     <div>
//                       <label className="block text-sm text-gray-600 mb-1">Social Icon *</label>
//                       <input
//                         type="file"
//                         accept="image/*"
//                         onChange={(e) => handleSocialLinkIcon(index, e.target.files[0])}
//                         className="w-full text-sm text-gray-500 file:mr-4 file:py-1 file:px-3 file:rounded file:border-0 file:bg-[#0bb6d9] file:text-white hover:file:bg-[#069ab7]"
//                       />
//                     </div>

//                     <div className="flex items-center gap-3">
//                       {link.iconPreview && (
//                         <div className="flex flex-col items-center">
//                           <span className="text-sm text-gray-600 mb-1">Preview:</span>
//                           <img
//                             src={link.iconPreview}
//                             alt="Social icon preview"
//                             className="w-12 h-12 rounded object-cover border"
//                           />
//                         </div>
//                       )}
//                       <button
//                         type="button"
//                         onClick={() => removeSocialLink(index)}
//                         className="text-red-500 self-end mb-1"
//                       >
//                         <Trash2 size={20} />
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//               <button
//                 type="button"
//                 onClick={addSocialLink}
//                 className="flex items-center text-[#0BB6D9] mt-2 hover:underline"
//               >
//                 <Plus size={18} className="mr-1" /> Add Social Link
//               </button>
//             </div>
//           </div>

//           <div className="border rounded-xl p-4 space-y-4">
//             <h4 className="font-semibold text-gray-800">Salary Information *</h4>
//             <div className="grid md:grid-cols-3 gap-4">
//               <div>
//                 <label className="block font-semibold text-gray-700 mb-1">
//                   Salary *
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.jobDetail.salary}
//                   onChange={(e) => handleJobDetailChange("salary", e.target.value)}
//                   placeholder="e.g., 50k-80k"
//                   className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                 />
//               </div>

//               <div>
//                 <label className="block font-semibold text-gray-700 mb-1">
//                   Currency *
//                 </label>
//                 <select
//                   value={formData.jobDetail.salaryCurrency}
//                   onChange={(e) => handleJobDetailChange("salaryCurrency", e.target.value)}
//                   className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                 >
//                   <option value="INR">INR</option>
//                   <option value="USD">USD</option>
//                   <option value="EUR">EUR</option>
//                   <option value="GBP">GBP</option>
//                 </select>
//               </div>

//               <div>
//                 <label className="block font-semibold text-gray-700 mb-1">
//                   Type *
//                 </label>
//                 <select
//                   value={formData.jobDetail.salaryType}
//                   onChange={(e) => handleJobDetailChange("salaryType", e.target.value)}
//                   className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                 >
//                   <option value="per month">Per Month</option>
//                   <option value="per year">Per Year</option>
//                   <option value="per hour">Per Hour</option>
//                   <option value="fixed">Fixed</option>
//                 </select>
//               </div>
//             </div>
//           </div>

//           <div className="border rounded-xl p-4 space-y-4">
//             <h4 className="font-semibold text-gray-800">Job Details *</h4>

//             <div>
//               <label className="block font-semibold text-gray-700 mb-1">
//                 Job Description *
//               </label>
//               {formData.jobDetail.jobDescription.map((desc, index) => (
//                 <div key={index} className="flex gap-2 mt-2">
//                   <input
//                     type="text"
//                     value={desc}
//                     onChange={(e) => handleArrayFieldChange("jobDescription", index, e.target.value)}
//                     placeholder={`Job description ${index + 1}`}
//                     className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                   />
//                   <button
//                     type="button"
//                     onClick={() => removeArrayFieldItem("jobDescription", index)}
//                     className="text-red-500"
//                   >
//                     <Trash2 size={20} />
//                   </button>
//                 </div>
//               ))}
//               <button
//                 type="button"
//                 onClick={() => addArrayFieldItem("jobDescription")}
//                 className="flex items-center text-[#0BB6D9] mt-2 hover:underline"
//               >
//                 <Plus size={18} className="mr-1" /> Add Job Description
//               </button>
//             </div>

//             <div>
//               <label className="block font-semibold text-gray-700 mb-1">
//                 Requirements *
//               </label>
//               {formData.jobDetail.requirements.map((req, index) => (
//                 <div key={index} className="flex gap-2 mt-2">
//                   <input
//                     type="text"
//                     value={req}
//                     onChange={(e) => handleArrayFieldChange("requirements", index, e.target.value)}
//                     placeholder={`Requirement ${index + 1}`}
//                     className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                   />
//                   <button
//                     type="button"
//                     onClick={() => removeArrayFieldItem("requirements", index)}
//                     className="text-red-500"
//                   >
//                     <Trash2 size={20} />
//                   </button>
//                 </div>
//               ))}
//               <button
//                 type="button"
//                 onClick={() => addArrayFieldItem("requirements")}
//                 className="flex items-center text-[#0BB6D9] mt-2 hover:underline"
//               >
//                 <Plus size={18} className="mr-1" /> Add Requirement
//               </button>
//             </div>

//             <div>
//               <label className="block font-semibold text-gray-700 mb-1">
//                 Desirable Skills
//               </label>
//               {formData.jobDetail.desirable.map((skill, index) => (
//                 <div key={index} className="flex gap-2 mt-2">
//                   <input
//                     type="text"
//                     value={skill}
//                     onChange={(e) => handleArrayFieldChange("desirable", index, e.target.value)}
//                     placeholder={`Desirable skill ${index + 1}`}
//                     className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                   />
//                   <button
//                     type="button"
//                     onClick={() => removeArrayFieldItem("desirable", index)}
//                     className="text-red-500"
//                   >
//                     <Trash2 size={20} />
//                   </button>
//                 </div>
//               ))}
//               <button
//                 type="button"
//                 onClick={() => addArrayFieldItem("desirable")}
//                 className="flex items-center text-[#0BB6D9] mt-2 hover:underline"
//               >
//                 <Plus size={18} className="mr-1" /> Add Desirable Skill
//               </button>
//             </div>

//             <div>
//               <label className="block font-semibold text-gray-700 mb-1">
//                 Benefits
//               </label>
//               {formData.jobDetail.benefits.map((benefit, index) => (
//                 <div key={index} className="flex gap-2 mt-2">
//                   <input
//                     type="text"
//                     value={benefit}
//                     onChange={(e) => handleArrayFieldChange("benefits", index, e.target.value)}
//                     placeholder={`Benefit ${index + 1}`}
//                     className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                   />
//                   <button
//                     type="button"
//                     onClick={() => removeArrayFieldItem("benefits", index)}
//                     className="text-red-500"
//                   >
//                     <Trash2 size={20} />
//                   </button>
//                 </div>
//               ))}
//               <button
//                 type="button"
//                 onClick={() => addArrayFieldItem("benefits")}
//                 className="flex items-center text-[#0BB6D9] mt-2 hover:underline"
//               >
//                 <Plus size={18} className="mr-1" /> Add Benefit
//               </button>
//             </div>

//             <div>
//               <label className="block font-semibold text-gray-700 mb-1">
//                 Overview *
//               </label>
//               {formData.jobDetail.overview.map((item, index) => (
//                 <div key={index} className="space-y-3 p-4 border rounded-lg bg-gray-50">
//                   <div className="grid md:grid-cols-2 gap-4">
//                     <div>
//                       <label className="block text-sm text-gray-600 mb-1">Title *</label>
//                       <input
//                         type="text"
//                         placeholder="e.g., Job Posted, Job Expire In"
//                         value={item.title}
//                         onChange={(e) => handleOverviewChange(index, "title", e.target.value)}
//                         className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                       />
//                     </div>
//                     <div>
//                       <label className="block text-sm text-gray-600 mb-1">Job Posted Date *</label>
//                       <input
//                         type="text"
//                         placeholder="e.g., 2 days ago, DD-MM-YY"
//                         value={item.jobPostedDate}
//                         onChange={(e) => handleOverviewChange(index, "jobPostedDate", e.target.value)}
//                         className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                       />
//                     </div>
//                   </div>

//                   <div className="grid md:grid-cols-2 gap-4">
//                     <div>
//                       <label className="block text-sm text-gray-600 mb-1">Icon *</label>
//                       <input
//                         type="file"
//                         accept="image/*"
//                         onChange={(e) => handleOverviewIcon(index, e.target.files[0])}
//                         className="w-full text-sm text-gray-500 file:mr-4 file:py-1 file:px-3 file:rounded file:border-0 file:bg-[#0bb6d9] file:text-white hover:file:bg-[#069ab7]"
//                       />
//                     </div>

//                     <div className="flex items-center gap-3">
//                       {item.iconPreview && (
//                         <div className="flex flex-col items-center">
//                           <span className="text-sm text-gray-600 mb-1">Preview:</span>
//                           <img
//                             src={item.iconPreview}
//                             alt="Overview icon preview"
//                             className="w-12 h-12 rounded object-cover border"
//                           />
//                         </div>
//                       )}
//                       <button
//                         type="button"
//                         onClick={() => removeOverview(index)}
//                         className="text-red-500 self-end mb-1"
//                       >
//                         <Trash2 size={20} />
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//               <button
//                 type="button"
//                 onClick={addOverview}
//                 className="flex items-center text-[#0BB6D9] mt-2 hover:underline"
//               >
//                 <Plus size={18} className="mr-1" /> Add Overview Item
//               </button>
//             </div>
//           </div>

//           <div className="flex items-center gap-5 pt-4 border-t">
//             <button
//               type="button"
//               onClick={onClose}
//               className="px-4 w-full py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={loading}
//               className="px-5 py-2 w-full rounded-lg bg-[#0BB6D9] text-white hover:bg-cyan-700 flex items-center justify-center gap-2"
//             >
//               {loading && <Loader2 className="animate-spin w-4 h-4" />}
//               <span>Create Career</span>
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default CareerCreateModal;